import { FC } from "react";
import ReactDOM from "react-dom";



type RootModalProps = {
  isModalVisible: boolean;
  children: JSX.Element;
  hideModal: () => void;
}

const RootModal: FC<RootModalProps> = ({ isModalVisible, children, hideModal }): JSX.Element => {
  const modalContent = (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''} loader-index`}
      id="exampleModal"
      tabIndex={-1}
      data-bs-backdrop="true"
      aria-hidden="true"
      onClick={hideModal}
    >{children}</div>
  )

  return ReactDOM.createPortal(modalContent, document.getElementById("modal-root")!)
}

export default RootModal
